import type { Family, FamilyKey } from "@/utils/types/flavor";

export const FLAVOR_FAMILIES: Record<FamilyKey, Family> = {
  fruity: { label: "Fruity", color: "var(--fam-fruity)" },
  floral: { label: "Floral", color: "var(--fam-floral)" },
  green: { label: "Green", color: "var(--fam-green)" },
  dairy: { label: "Dairy", color: "var(--fam-dairy)" },
  citrus: { label: "Citrus", color: "var(--fam-citrus)" },
  spicy: { label: "Spicy", color: "var(--fam-spicy)" },
  roast: { label: "Roast", color: "var(--fam-roast)" },
  sweet: { label: "Sweet", color: "var(--fam-sweet)" },
  neutral: { label: "Neutral", color: "var(--fam-neutral)" },
};
